import React, { useState } from 'react'
 
 
import ProductList from './ProductList';
import ProductForm from './ProductForm';

const Product= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <ProductForm addForm={setFromIsShown} update={upData} sId={serviceId}/>
        ) : (
          <ProductList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
        )}
  
    </>
  )
}

export default Product